import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import toast, { Toaster } from 'react-hot-toast'
import App from './App.jsx'
import { AuthProvider } from './contexts/AuthContext.jsx'
import { WebSocketProvider } from './contexts/WebSocketContext.jsx'
import { MarketAutomationProvider } from './contexts/MarketAutomationContext.jsx'
import { addErrorLog } from './utils/errorLog.js'
import './index.css'

// ── Redirect ALL toast.error() calls to the error log ───────────────────────
// Every component that calls toast.error(msg) gets its message captured here
// instead of showing a popup.  toast.success() / toast() remain as normal.
toast.error = (message /*, opts — ignored */) => {
  addErrorLog(typeof message === 'string' ? message : String(message))
}
// toast.warning doesn't exist natively in react-hot-toast but some callers
// may use it via custom — route that too.
toast.warning = (message) => {
  addErrorLog(typeof message === 'string' ? message : String(message))
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <WebSocketProvider>
          <MarketAutomationProvider>
            <App />
            <Toaster 
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#363636',
                  color: '#fff',
                },
                success: {
                  duration: 3000,
                  iconTheme: {
                    primary: '#22c55e',
                    secondary: '#fff',
                  },
                },
                error: {
                  duration: 5000,
                  iconTheme: {
                    primary: '#ef4444',
                    secondary: '#fff',
                  },
                },
              }}
            />
          </MarketAutomationProvider>
        </WebSocketProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
)